export default [
    {
        method: "sendSms",
        type: 'POST',
        path: '/web/sms/generic/send',
        mode: 'passport',
        params: ["cid","tel","type","captcha"],
        options: { withCredentials: true, cache: false, },
        switch: false,
        // desc: '注册时发送短信接口'
    },
    {
        method: "signUp",
        type: 'POST',
        path: '/web/reg/by/tel',
        mode: 'passport',
        params: ["cid","tel","code","nickName", "pwd", "repeatPwd"],
        options: { cache: false, },
        switch: false,
        // desc: '注册账号接口'
    },
    {
        method: "sendEmailCode",
        type: 'POST',
        path: '/web/captcha/generic/send',
        mode: 'passport',
        params: ["user", "type","captcha"],
        options: {  withCredentials: true, cache: false,  },
        switch: false,
        // desc: '注册时发送邮箱验证码接口'
    },
    {
        method: "emailSignUp",
        type: 'POST',
        path: '/web/reg/email',
        mode: 'passport',
        params: ["user","pwd","rePwd","captcha"],
        options: { cache: false, },
        switch: false,
        // desc: '邮箱注册账号接口'
    },
    {
        method: "getPublicKey",
        type: 'GET',
        path: '/web/rsa_public',
        mode: 'passport',
        params: [],
        options: { cache: false },
        switch: false,
        // desc: '登录获取public_ley'
    }
];